module.exports = __webpack_public_path__ + "static/media/sell_send_money_8.c85ae4a4.jpg";